import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import { useCurrentUser } from '../hooks';

const AdOptionsDropdown = props => {

  return (
    <Menu
      anchorEl={props.anchorEl}
      open={props.isOpen}
      onClose={props.hideMenu}
      data-testid="ad-options-dropdown"
    >
      <MenuItem
        className="ad-option view-content-button"
        onClick={props.handleViewContent}
      >
        View Content
      </MenuItem>
      <CopyToClipboard text={props.viewLink} onCopy={props.copyViewLink}>
        <MenuItem className="ad-option" disabled={!props.viewLink}>
          <span>Copy View Link</span>
        </MenuItem>
      </CopyToClipboard>
      <CopyToClipboard text={props.editLink} onCopy={props.copyEditLink}>
        <MenuItem className="ad-option" disabled={!props.editLink}>
          <span>Copy Edit Link</span>
        </MenuItem>
      </CopyToClipboard>
      <CopyToClipboard text={props.embedLink} onCopy={props.copyEmbedLink}>
        <MenuItem className="ad-option" disabled={!props.embedLink}>
          <div>Copy Embed Link</div>
        </MenuItem>
      </CopyToClipboard>
      {props.integrationLink && (
        <CopyToClipboard
          text={props.integrationLink}
          onCopy={props.copyIntegrationLink}
        >
          <MenuItem className="ad-option">
            <span>Copy Integration Link</span>
          </MenuItem>
        </CopyToClipboard>
      )}
    </Menu>
  );
};

AdOptionsDropdown.propTypes = {
  anchorEl: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  hideMenu: PropTypes.func.isRequired,
  handleViewContent: PropTypes.func.isRequired,
  handleEditAd: PropTypes.func.isRequired,
  viewLink: PropTypes.string,
  copyViewLink: PropTypes.func.isRequired,
  editLink: PropTypes.string,
  copyEditLink: PropTypes.func.isRequired,
  embedLink: PropTypes.string,
  copyEmbedLink: PropTypes.func.isRequired,
  integrationLink: PropTypes.string,
  copyIntegrationLink: PropTypes.func.isRequired,
  adType: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired
};

AdOptionsDropdown.defaultProps = {
  anchorEl: {},
  viewLink: null,
  editLink: null,
  embedLink: null,
  integrationLink: null
};

export default AdOptionsDropdown;
